import CustomCard from '../../../../../../components/CustomCard';
import { ArrowRightIcon } from '../../../../../../components/buttons/IconButtons';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 * s
 */
const PaymentItem = ({ title, subtitle, icon, click, classNameContainer = "w-56px-h-56px background-primary-100" }) => {

    return (
        <CustomCard
            classCard={'card-border-8px'}
            click={() => {
                click()
            }}
        >
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                    <div className={`${classNameContainer} d-flex align-items-center justify-content-center mr-3`}>
                        {icon}
                    </div>
                    <div className="d-flex flex-column">
                        <p className="fs-16px ibl-font-w-600 font-color-general-950">{title}</p>
                        <p className="fs-14px ibl-font-w-400 font-color-shades-700">{subtitle}</p>
                    </div>
                </div>
                <div className="d-flex w-56px-h-56px">
                    <ArrowRightIcon className="icon-color-shades-400 w-100 h-100" />
                </div>
            </div>
        </CustomCard>
    );

}

export default PaymentItem
